import * as Styled from './styled'
import { Button, Text } from 'common-components'
import EmptyHistoryIcon from 'assets/svgr-icons/EmptyHistory.svg'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { TabKey } from '../../consts'
import { memo, useCallback } from 'react'
import { dispatch } from 'store'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'

const EmptyState = () => {
  const handleGenerateClick = useCallback(() => {
    dispatch(aiVideoThunks.setActiveTab(TabKey.GENERATE))
  }, [])

  return (
    <Styled.EmptyState>
      <EmptyHistoryIcon />
      <Text type="h1" color="secondarySemiDark" align="center">
        {translate(T.HISTORY_EMPTY_TITLE)}
      </Text>
      <Text type="h2" color="secondary" align="center">
        {translate(T.HISTORY_EMPTY_DESCRIPTION_AI_VIDEO)}
      </Text>
      <Button type="white" onClick={handleGenerateClick}>
        <Text type="h2" color="primaryDark">
          {translate(T.GENERATE_LABEL)}
        </Text>
      </Button>
    </Styled.EmptyState>
  )
}

export default memo(EmptyState)
